import { lazy, Suspense } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Layout as DashboardLayout } from "src/layouts/dashboard";
import { subDays } from "date-fns";
import { DEFAULT_DAYS_ON_CHART } from "src/config";
import Plans from "src/pages/dashboard/whitelabel/plans";
import ManageUser from "src/pages/dashboard/whitelabel/manage-user";
import BrandingManagement from "src/pages/dashboard/whitelabel/brandingmanagement";
import SeoSetting from "src/pages/dashboard/whitelabel/SeoSetting";
import CustomDomain from "src/pages/dashboard/whitelabel/CustomDomain";
import Viewdomain from "src/pages/dashboard/whitelabel/view-domain";
import SupportCenter from "src/pages/dashboard/whitelabel/supportCenter";

const IndexPage = lazy(() => import("src/pages/dashboard/index"));
const IntegarionsPage = lazy(() => import("src/pages/dashboard/integrations"));
const DFYInfraSetupOrderStatus = lazy(() =>
  import("src/pages/dashboard/emailAccounts/orderStatus")
);
const DFYInfraSetupAddNew = lazy(() =>
  import("src/pages/dashboard/emailAccounts/AddNew")
);
const Error404Page = lazy(() => import("src/pages/dashboard/404"));

// Academy
const AcademyDashboardPage = lazy(() =>
  import("src/pages/dashboard/academy/dashboard")
);
const AcademyCoursePage = lazy(() =>
  import("src/pages/dashboard/academy/course")
);

// Blog
const BlogPostListPage = lazy(() => import("src/pages/dashboard/blog/list"));
const BlogPostDetailPage = lazy(() =>
  import("src/pages/dashboard/blog/detail")
);
const BlogPostCreatePage = lazy(() =>
  import("src/pages/dashboard/blog/create")
);

// Customers
const CustomerListPage = lazy(() =>
  import("src/pages/dashboard/customers/list")
);
const CustomerDetailPage = lazy(() =>
  import("src/pages/dashboard/customers/detail")
);
const CustomerEditPage = lazy(() =>
  import("src/pages/dashboard/customers/edit")
);

// CRM
const DealPieline = lazy(() => import("src/pages/dashboard/crm/dealPipeline"));

// Invoice
const InvoiceListPage = lazy(() => import("src/pages/dashboard/invoices/list"));
const InvoiceDetailPage = lazy(() =>
  import("src/pages/dashboard/invoices/detail")
);

// Jobs
const JobBrowsePage = lazy(() => import("src/pages/dashboard/jobs/browse"));
//const JobCreatePage = lazy(() => import("src/pages/dashboard/jobs/create"));
const JobCreatePage = lazy(() => import("src/pages/dashboard/jobs/campaign"));
const CompanyDetailPage = lazy(() =>
  import("src/pages/dashboard/jobs/companies/detail")
);
const JobCreateAiPage = lazy(() =>
  import("src/pages/dashboard/jobs/chat-campaign")
);

// Logistics
const LogisticsDashboardPage = lazy(() =>
  import("src/pages/dashboard/logistics/dashboard")
);
const LogisticsFleetPage = lazy(() =>
  import("src/pages/dashboard/logistics/fleet")
);

// Orders
const OrderListPage = lazy(() => import("src/pages/dashboard/orders/list"));
const OrderDetailPage = lazy(() => import("src/pages/dashboard/orders/detail"));

// Products
const ProductListPage = lazy(() => import("src/pages/dashboard/products/list"));
const ProductCreatePage = lazy(() =>
  import("src/pages/dashboard/products/create")
);

// Social
const SocialFeedPage = lazy(() => import("src/pages/dashboard/social/feed"));
const SocialProfilePage = lazy(() =>
  import("src/pages/dashboard/social/profile")
);

// Other
const AccountPage = lazy(() => import("src/pages/dashboard/account"));
const AnalyticsPage = lazy(() => import("src/pages/dashboard/analytics"));
const BlankPage = lazy(() => import("src/pages/dashboard/blank"));
const CalendarPage = lazy(() => import("src/pages/dashboard/calendar"));
const ChatPage = lazy(() => import("src/pages/dashboard/chat"));
const SupportCenterPage = lazy(() =>
  import("src/pages/dashboard/supportCenter")
);
const CryptoPage = lazy(() => import("src/pages/dashboard/crypto"));
const EcommercePage = lazy(() => import("src/pages/dashboard/ecommerce"));
const FileManagerPage = lazy(() => import("src/pages/dashboard/file-manager"));
const KanbanPage = lazy(() => import("src/pages/dashboard/kanban"));
const MailPage = lazy(() => import("src/pages/dashboard/mail"));
const MailRepliesPage = lazy(() => import("src/pages/dashboard/mailReplies"));
const ConversationsPage = lazy(() =>
  import("src/pages/dashboard/salesConversation")
);
const UserConversationsPage = lazy(() =>
  import("src/pages/dashboard/conversations")
);

const MainConversationPage = lazy(() =>
  import("src/pages/dashboard/mainconversation")
);
const AllCustomers = lazy(() =>
  import("src/pages/dashboard/customers/allCustomers")
);
const ComingSoon = lazy(() => import("src/pages/dashboard/ComingSoon"));
const DashboardPage = lazy(() => import("src/pages/dashboard/dashboard"));
const SpamCheckerPage = lazy(() =>
  import("src/pages/dashboard/freeTools/spam-checker")
);
const MeetingSchedulerPage = lazy(() =>
  import("src/pages/dashboard/freeTools/meeting-scheduler")
);
const EventTypePage = lazy(() =>
  import(
    "src/sections/dashboard/free-tools/meeting-scheduler/create-event-type"
  )
);
const ProspectListsPage = lazy(() =>
  import("src/pages/dashboard/prospects/listV2/index")
);

const ProspectSearchPage = lazy(() =>
  import("src/pages/dashboard/prospects/Search")
);
const ProspectEnrichmentPage = lazy(() =>
  import("src/pages/dashboard/prospects/Enrichment")
);

const EmailAccountsManagePage = lazy(() =>
  import("src/pages/dashboard/emailAccounts/Manage")
);

const NewDashboardPage = lazy(() => import("src/pages/dashboard/dashboard"));
const WhiteLabelPage = lazy(() => import("src/pages/dashboard/white-label"));
const DomainPage = lazy(() => import("src/pages/dashboard/domain"));
const AllAgentsPage = lazy(() => import("src/pages/dashboard/agent/index"));
const FileManagerknowledge = lazy(() =>
  import("src/pages/dashboard/agent/knowledge-center")
);
const AgentSetupPage = lazy(() =>
  import("src/pages/dashboard/agent/agent-setup")
);
export const dashboardRoutes = [
  {
    path: "dashboard",
    element: (
      <DashboardLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </DashboardLayout>
    ),
    children: [
      {
        index: true,
        element: <Error404Page />,
      },
      { path: "bdraiagent", element: <ComingSoon /> },
      { path: "dashboard", element: <NewDashboardPage /> },
      {
        path: "leads",
        children: [
          {
            index: true,
            element: <CustomerListPage />,
          },
          {
            path: "all",
            element: <AllCustomers />,
          },
        ],
      },
      { path: "integrations", element: <IntegarionsPage /> },
      {
        path: "academy",
        children: [
          {
            index: true,
            element: <AcademyDashboardPage />,
          },
          {
            path: "courses",
            children: [
              {
                path: ":courseId",
                element: <AcademyCoursePage />,
              },
            ],
          },
        ],
      },
      {
        path: "blog",
        children: [
          {
            index: true,
            element: <BlogPostListPage />,
          },
          {
            path: "create",
            element: <BlogPostCreatePage />,
          },
          {
            path: ":postId",
            element: <BlogPostDetailPage />,
          },
        ],
      },
      {
        path: "white-label",
        children: [
          {
            index: true,
            element: <WhiteLabelPage />,
          },
          {
            path: "plans",
            element: <Plans />,
          },
          {
            path: "manage-user",
            element: <ManageUser />,
          },
          {
            path: "brandingmanagement",
            element: <BrandingManagement />,
          },
          {
            path: "seosetting",
            element: <SeoSetting />,
          },
          {
            path: "customdomain",
            element: <CustomDomain />,
          },
          {
            path: "supportcenter",
            element: <SupportCenter />,
          },
          {
            path: "view-domain",
            element: <Viewdomain />,
          },
        ],
      },
      {
        path: "contacts",
        children: [
          {
            index: true,
            element: <CustomerListPage />,
          },
          {
            path: "all",
            element: <AllCustomers />,
          },
          {
            path: ":customerId",
            element: <CustomerDetailPage />,
          },
          {
            path: ":customerId/edit",
            element: <CustomerEditPage />,
          },
        ],
      },
      {
        path: "userconversations",
        children: [
          {
            index: true,
            element: <UserConversationsPage />,
          },
        ],
      },
      {
        path: "conversations",
        children: [
          {
            index: true,
            element: <ConversationsPage />,
          },
        ],
      },
      {
        path: "emailreplies",
        children: [
          {
            index: true,
            element: <ConversationsPage />,
          },
        ],
      },
      {
        path: "mainconversation",
        children: [
          {
            index: true,
            element: <MainConversationPage />,
          },
        ],
      },
      {
        path: "invoices",
        children: [
          {
            index: true,
            element: <InvoiceListPage />,
          },
          {
            path: ":invoiceId",
            element: <InvoiceDetailPage />,
          },
        ],
      },
      {
        path: "campaigns",
        children: [
          {
            index: true,
            element: <JobBrowsePage />,
          },
          {
            path: "create",
            element: <JobCreatePage />,
          },
          {
            path: "edit",
            element: <JobCreatePage />,
          },
          {
            path: ":campaignId",
            element: <JobCreatePage />,
          },
          {
            path: "chat-campaign",
            element: <JobCreateAiPage />,
          },
          {
            path: "companies",
            children: [
              {
                path: ":companyId",
                element: <CompanyDetailPage />,
              },
            ],
          },
        ],
      },
      {
        path: "crm",
        children: [
          {
            path: "index",
            // element: <ProspectListsPage />,
            element: <DealPieline />,
          },
          {
            path: "lists",
            element: <ProspectListsPage />,
            // element: <ComingSoon />
          },
          {
            path: "people-search",
            element: <ProspectSearchPage />,
            // element: <ComingSoon />
          },
          {
            path: "company-search",
            element: <ProspectSearchPage />,
            // element: <ComingSoon />
          },
          {
            path: "enrich",
            element: <ProspectEnrichmentPage />,
          },
          {
            path: "validate",
            element: <ComingSoon />,
          },
          {
            path: "cleanup",
            element: <ComingSoon />,
          },
          {
            path: "intentdata",
            element: <ComingSoon />,
          },
        ],
      },
      {
        path: "emailAccounts",
        element: <Outlet />,
        children: [
          {
            path: "purchase",
            element: lazy(() => import("src/pages/dashboard/emailAccounts/purchase")),
          },
          {
            path: "*",
            element: <Navigate to="/dashboard/emailaccounts" replace />,
          },
        ],
      },
      {
        path: "emailaccounts",
        // element: <ComingSoon />,
        children: [
          {
            index: true,
            // element: <ProspectListsPage />,
            element: <ComingSoon />,
          },
          {
            path: "manage",
            // element: <ProspectListsPage />,
            element: <EmailAccountsManagePage />,
          },
          {
            path: "purchase",
            element: lazy(() => import("src/pages/dashboard/emailAccounts/purchase")),
          },
          {
            path: "*",
            element: <ComingSoon />,
          },
          {
            path: "unifiedinbox",
            // element: <ProspectListsPage />,
            element: <ComingSoon />,
          },
          {
            path: "engagecampaigns",
            element: <ComingSoon />,
          },
          {
            path: "orderstatus",
            element: <DFYInfraSetupOrderStatus />,
          },
          {
            path: "orderstatus/add",
            element: <DFYInfraSetupAddNew />
          },
        ],
      },
      {
        path: "freetools",
        children: [
          {
            index: true,
            element: <ComingSoon />,
          },

          {
            path: "spamchecker",
            element: <SpamCheckerPage />,
          },
          {
            path: "unifiedcalendar",
            element: <ComingSoon />,
          },
          {
            path: "unifiedinbox",
            element: <ComingSoon />,
          },
          {
            path: "meetingscheduler",
            children: [
              {
                index: true,
                element: <ComingSoon />,
              },
              {
                path: "event_types",
                element: <ComingSoon />,
              },
            ],
          },
        ],
      },
      {
        path: "logistics",
        children: [
          {
            index: true,
            element: <LogisticsDashboardPage />,
          },
          {
            path: "fleet",
            element: <LogisticsFleetPage />,
          },
        ],
      },
      // {
      //   path: "campaigns",
      //   children: [
      //     {
      //       index: true,
      //       element: <OrderListPage />,
      //     },
      //     {
      //       path: ":orderId",
      //       element: <OrderDetailPage />,
      //     },
      //   ],
      // },
      {
        path: "icp",
        children: [
          {
            index: true,
            element: <ProductCreatePage />,
          },
          {
            path: "create",
            element: <ProductListPage />,
          },
        ],
      },
      {
        path: "social",
        children: [
          {
            path: "feed",
            element: <SocialFeedPage />,
          },
          {
            path: "profile",
            element: <SocialProfilePage />,
          },
        ],
      },
      {
        path: "replies",
        element: <MailRepliesPage />,
      },
      {
        path: "account",
        element: <AccountPage />,
      },
      {
        path: "domain",
        element: <DomainPage />,
      },
      {
        path: "analytics",
        element: <AnalyticsPage />,
      },
      {
        path: "blank",
        element: <BlankPage />,
      },
      {
        path: "calendar",
        element: <CalendarPage />,
      },
      {
        path: "chat",
        element: <ChatPage />,
      },
      // ...(window.location.hostname === "app.b2brocket.ai" ||
      // window.location.hostname === "localhost"
      //   ? [
      {
        path: "supportCenter",
        element: <SupportCenterPage />,
      },
      //   ]
      // : []),
      {
        path: "upgrade",
        element: <ComingSoon />,
      },
      {
        path: "onboardingHub",
        element: <ComingSoon />,
      },
      {
        path: "crypto",
        element: <CryptoPage />,
      },
      {
        path: "ecommerce",
        element: <EcommercePage />,
      },
      {
        path: "file-manager",
        element: <FileManagerPage />,
      },
      {
        path: "kanban",
        element: <KanbanPage />,
      },
      {
        path: "mail",
        element: <MailPage />,
      },
      {
        path: "agents",
        children: [
          {
            index: true,
            element: <AllAgentsPage />,
          },
          {
            path: ":agentId",
            element: <AgentSetupPage />,
          },
        ],
      },
      {
          path: "knowledge",
          element: <FileManagerknowledge />,
          children: [
            {
              path: ":folderId",
              element: <FileManagerknowledge />,
            },
          ],
      },
      {
        path: "*",
        element: <Error404Page />,
      },
    ],
  },
];
